import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { LayoutModal } from "../../../general/modules/commons/layoutModal/layoutModal";
import { connectUserRelation } from "../../infrastructure/slices/RelationSlice";
import { toast } from "sonner";
import { EntitySelectField } from "../../../general/fields/modules/commons/entitySelectField/entitySelectField";
import { driverSchema } from "../../../planning/truck/domain/schema/truckFormSchema";
import useCrudFilters from "../../../../hooks/useCrudFilters";
import { useState } from "react";

export const RelationAddExistingUserModal = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const [userId, setUserId] = useState<number>();
  const dispatch = useAppDispatch();
  const { id } = useParams();

  const userFilters = useCrudFilters({
    searchBy: "SearchByRootUser",
    fields: {
      roles: {
        fields: {
          name: {
            in: ["dealer-employee"],
          },
        },
      },
    },
  });

  const submitAddExistingUser = () => {
    if (userId) {
      void dispatch(
        connectUserRelation({
          userId: userId,
          relationId: parseInt(id ?? ""),
        }),
      ).then(() => {
        navigate(-1);
      });
    } else {
      toast.error(t("Please select a employee"));
    }
  };

  return (
    <LayoutModal
      title={t("Add existing user")}
      show={true}
      onHide={() => navigate(-1)}
      actions={
        <Button onClick={() => submitAddExistingUser()}>{t("Save")}</Button>
      }
    >
      <Form.Group className="mb-3">
        <Form.Label>{t("Employee")}</Form.Label>
        <EntitySelectField
          filters={userFilters.filters}
          prefix="users"
          entity="User"
          labelPrefix={"name"}
          id={"users.id"}
          key={"users.id"}
          value={userId}
          name={"users.id"}
          onChange={(option) => {
            if (option === null) return;
            setUserId((option as { value: number }).value);
          }}
          schema={driverSchema}
          limit={1000000}
        />
      </Form.Group>
    </LayoutModal>
  );
};
